import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { HttpErrorResponse } from "@angular/common/http";
import { InsuranceHubService } from "../services/Insurance-hub.service";
import { Router } from "@angular/router";



 @Component({
   template: ''
 })
 
 export class InsuranceHubBaseComponent implements OnInit {
     @ViewChild('callbackSuccessModel', { static: false }) callbackSuccessModel: ElementRef;
   public PolicyDetailResponse: any = {};
   public UserPolicyDetails: any;
    modalOptions: NgbModalOptions;
     eRef: ElementRef;
   constructor(private insuranceHubService: InsuranceHubService,   private modalService: NgbModal,
    private elementRef: ElementRef,private router: Router) { }


   ngOnInit(): void {
    this.GetPolicyDetails();

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      keyboard: false
    };
    this.eRef=this.elementRef;
  }
  
  GetPolicyDetails() {
  
    this.insuranceHubService.GetUserPolicyListWithDetails().subscribe({
    next: (data: any) => {
      this.UserPolicyDetails = data;
       if(this.UserPolicyDetails?.isDataAvailable==false)
      {
        this.router.navigate(['/portal/dashboard']);
      }
    }
    });
  }

 CallBackRequestEmail(id: number) {
    if (this.PolicyDetailResponse) {
     this.RequestCallBackEmail(id, this.PolicyDetailResponse);
    }
  }

  RequestCallBackEmail(id: number, policyDetails: any) {
    var payload = {
      emailTemplateType: id,
      insuranceHubPolicyResponse: policyDetails
    }
     this.insuranceHubService.RequestCallBackEmail(payload).subscribe({
        next: (data: any) => {
          this.modalService.dismissAll();
          this.modalService.open(this.callbackSuccessModel, this.modalOptions);
        }, error: (err: HttpErrorResponse) => {
          this.modalService.dismissAll();
                this.modalService.open(this.callbackSuccessModel, this.modalOptions);
        }});    
  }
  
  CallBackLms(campaignSource: string) {
    if (this.PolicyDetailResponse) {
      var payload = {
        campaignSource: campaignSource
            }
      this.insuranceHubService.RequestCallBackFSLms(payload).subscribe({
        next: (data: any) => {
          this.modalService.dismissAll();
          this.modalService.open(this.callbackSuccessModel, this.modalOptions);
        }, error: (err: HttpErrorResponse) => {
          this.modalService.dismissAll();
                this.modalService.open(this.callbackSuccessModel, this.modalOptions);
        }});
    }
  }
  
}